import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNavAdmin({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M14.82 9.75l-1.25-.72a6 6 0 000-2.07l1.25-.73a.33.33 0 00.16-.4c-.32-1.06-.88-2-1.6-2.8a.35.35 0 00-.45-.07l-1.25.73a5.56 5.56 0 00-1.8-1.04V1.21a.35.35 0 00-.27-.35 7.41 7.41 0 00-3.22 0 .35.35 0 00-.28.35v1.45c-.65.23-1.26.58-1.8 1.03l-1.24-.72a.35.35 0 00-.44.06 7.3 7.3 0 00-1.61 2.8c-.05.15.01.32.16.4l1.25.73a5.68 5.68 0 000 2.07l-1.25.73a.36.36 0 00-.16.41c.32 1.05.88 2 1.6 2.79.12.12.3.15.45.07l1.25-.73c.53.46 1.14.8 1.8 1.04v1.45c0 .16.1.3.27.34 1.08.24 2.2.23 3.22 0a.35.35 0 00.28-.34v-1.45a5.74 5.74 0 001.8-1.04l1.25.73c.14.08.32.05.43-.07A7.3 7.3 0 0015 10.17a.36.36 0 00-.17-.42zm-6.82.6a2.36 2.36 0 110-4.72 2.36 2.36 0 010 4.72z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgNavAdmin.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNavAdmin.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgNavAdmin svgRef={ref} {...props} />);
export default ForwardRef;
